import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const StyledBreadcrumbs = styled(Breadcrumbs)`
    margin-top: 14px;
`;

interface KeyBreadCrumbsProps {
    keyName?: string;
}

const KeysBreadCrumbs: React.FC<KeyBreadCrumbsProps> = ({ keyName }) => {
    const { t } = useTranslation('admin_settings');
    const history = useHistory();
    return (
        <StyledBreadcrumbs>
            <Link underline="hover" variant="body1" onClick={() => history.goBack()}>
                {t('api-keys.api-keys')}
            </Link>
            <Typography variant="body1" color="text.primary">
                {keyName || t('create')}
            </Typography>
        </StyledBreadcrumbs>
    );
};

export default KeysBreadCrumbs;
